import { toAbsoluteUrl } from '@/util/to-absolute-url';

import { apiGtm } from '../lib/apiGtm';
import { GTMEventPromotion } from '../lib/types';

export type GTMPromotion = NonNullable<
  GTMEventPromotion['ecommerce']['promoView']
>['promotions'][number];

const getCreativeSlot = (url?: string | null) =>
  url?.trim() ? toAbsoluteUrl(url.trim()) : 'internal';

const getPromotionPosition = (trackingName: string, index: number): string | number => {
  if (trackingName === 'collections') {
    return `collections::${index + 1}`;
  }

  return trackingName;
};

export const buildBannerPromotion = (params: {
  id?: string | null;
  name: string;
  imageUrl: string;
  linkUrl?: string | null;
  trackingName: string;
  index: number;
}): GTMPromotion | undefined => {
  const name = params.name.trim();
  if (!name || !params.imageUrl) return undefined;

  return {
    id: String(params.id ?? params.index + 1),
    name,
    creative: params.imageUrl,
    position: getPromotionPosition(params.trackingName, params.index),
    creative_slot: getCreativeSlot(params.linkUrl)
  };
};

export const sendViewPromotion = (promotion: GTMPromotion) => {
  apiGtm.viewPromotion({
    ecommerce: {
      promoView: {
        promotions: [promotion]
      }
    }
  });
};
